"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NSimulationProductDTOConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NSimulationProductDTOConverter, _NotificationDocConve);

  function NSimulationProductDTOConverter() {
    _classCallCheck(this, NSimulationProductDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NSimulationProductDTOConverter).apply(this, arguments));
  }

  return NSimulationProductDTOConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NSimulationProductDTOConverter = NSimulationProductDTOConverter;